// Popover

$(function () {
  $('[data-toggle="popover"]').popover({
    trigger: 'hover focus',
    placement: 'top',
    container: 'body',
  });

  $('.jsPopoverContent').each(function (index, element) {
    $(element).popover({
      trigger: 'hover focus',
      placement: 'top',
      container: 'body',
      content:  $(this).text(),
    });
  });
});
